export default __webpack_public_path__ + "static/media/header-logo.b81e8554.jpg";